@let nameValue = name();
@let subcategoriesValue = subcategories();
@let isParentCategoryValue = isParentCategory();
@let buttonDisabledValue = buttonDisabled();
@let imageB64Value = imgBase64();
@let photoFromParentCategoryInternalValue = photoFromParentCategoryInternal();
@let fileNameToDisplayInternalValue = fileNameToDisplayInternal();

<div [ngClass]="{ 'category-section': isParentCategoryValue, 'py-2': isParentCategoryValue, 'px-4': isParentCategoryValue, 'px-2': !isParentCategoryValue }">
    <div class="d-flex flex-row justify-content-between align-items-center">
        <div class="d-flex flex-row align-items-center">
            @if (imageB64Value) {
                <img class="mr-2 p-2" [src]="imageB64Value" [ngClass]="{ 'opacity-40': photoFromParentCategoryInternalValue }" />
            }

            <div class="category-name size-16">{{ nameValue }}</div>
        </div>
        <div class="d-flex flex-row justify-content-center align-items-center gap-4" [ngClass]="{ 'pr-3': isParentCategoryValue }">
            @if (!imageB64Value || photoFromParentCategoryInternalValue) {
                <input type="file" #fileInput [accept]="'image/png, image/jpeg'" (change)="onFileSelected($event)" />
                <div class="inherited-image m-2">{{ fileNameToDisplayInternalValue }}</div>
                <button class="btn btn-success m-2" (click)="fileInput.click()" [disabled]="buttonDisabledValue">Add</button>
            } @else {
                <div class="m-2">{{ fileNameToDisplayInternalValue }}</div>
                <button class="btn btn-danger m-2" (click)="onRemoveClicked()">Remove</button>
            }
        </div>
    </div>
    @if (isParentCategoryValue && subcategoriesValue && subcategoriesValue.length > 0) {
        <div class="p-2 category-section">
            @for (subcategory of subcategoriesValue; track subcategory.id; let isLast = $last) {
                <div [ngClass]="{ subcategory: !isLast }">
                    <app-camp-category-section
                        [photoFromParentCategory]="subcategory.photoBelongsToParentCategory"
                        [parentImgBase64]="imgBase64()"
                        [imgUrl]="subcategory.photoUrl()"
                        [isParentCategory]="false"
                        [name]="subcategory.name"
                        [campCategoryId]="subcategory.id"
                    ></app-camp-category-section>
                </div>
            }
        </div>
    }
</div>
